import request from '@/request'

export async function getLiveStatus (liveId) {
  const response = await request({
    url: `/lives/${liveId}/status`,
    method: 'get'
  })

  return response.data.data
}

export async function getScheduled () {
  const response = await request({
    url: '/lives/scheduled',
    method: 'get'
  })

  return response.data.data
}

export async function fetchLive (liveId) {
  const response = await request({
    url: `/lives/${liveId}`,
    method: 'get'
  })
  return response.data.data
}

export async function fetchUserLiveReminder (userId, liveId) {
  const response = await request({
    url: `/users/${userId}/lives/${liveId}/reminder`,
    method: 'get'
  })
  return response.data.data
}

export async function liveReminderSignUp (liveId) {
  const response = await request({
    url: `/lives/${liveId}/reminder`,
    method: 'post'
  })
  return response.data.data
}

export async function fetchPremiumLives (params = {}) {
  const res = await request({
    url: `/v2/lives/premium`,
    method: 'get',
    params,
  })

  return res.data
}